import persistReducer from "redux-persist/lib/persistReducer";
import storage from "redux-persist/lib/storage";
import { masterConstants } from "./masterConstants";

const initialState = {
    riskAssessmentQuestions: [],
    riskProfiles: [],
    brokers: [],
    riskData: [],
    firstRender : true,
    // onestockBrokers: [],
    pendingCall: {
        isMobileVerified: null,
        isEmailVerified: null,
        portfolioData: {},
        protectData: {},
        onestockData: {},
        primeData: {},
        sentimentData: {}
    },
    loading: {
        riskAssessmentQuestions: 0,
        riskProfiles: 0,
        brokers: 0,
        riskData: 0,
        // onestockBrokers: 0,
        pendingCall: 0,
        firstRender : false,
    },
    initialCalled: {
        riskAssessmentQuestions: 0,
        riskProfiles: 0,
        brokers: 0,
        riskData: 0,
        // onestockBrokers: 0,
        pendingCall: 0,
        firstRender : true,
    },
};

export const masterReducers = persistReducer(
    {
        storage,
        key: "master",
        whitelist: ["riskData"],
    },

    (state = initialState, { type, payload }) => {
        
        switch (type) {
            case masterConstants.RMS_RISK_ASSESSMENT_QUESTIONS_REQUEST: {
                return {
                    ...state,
                    loading: {
                        ...state.loading,
                        riskAssessmentQuestions: 1,
                    },
                    riskAssessmentQuestions:
                        initialState.riskAssessmentQuestions,
                };
            }

            case masterConstants.RMS_RISK_ASSESSMENT_QUESTIONS_RESPONSE: {
                return {
                    ...state,
                    loading: {
                        ...state.loading,
                        riskAssessmentQuestions: 0,
                    },
                    riskAssessmentQuestions: payload,
                };
            }

            case masterConstants.RMS_RISK_PROFILES_REQUEST: {
                return {
                    ...state,
                    loading: {
                        ...state.loading,
                        riskProfiles: 1,
                    },
                    riskProfiles: initialState.riskProfiles,
                };
            }

            case masterConstants.RMS_RISK_PROFILES_RESPONSE: {
                return {
                    ...state,
                    loading: {
                        ...state.loading,
                        riskProfiles: 0,
                    },
                    riskProfiles: payload,
                };
            }

            case masterConstants.MASTER_BROKER_REQUEST: {
                return {
                    ...state,
                    brokers: initialState.brokers,
                    loading: {
                        ...state.loading,
                        brokers: 1
                    }
                }
            }

            case masterConstants.MASTER_BROKER_RESPONSE: {
                return {
                    ...state,
                    brokers: payload,
                    loading: {
                        ...state.loading,
                        brokers: 0,
                    },
                    initialCalled: {
                        ...state.initialCalled,
                        brokers: 1,
                    }
                }
            }

            // case masterConstants.ONESTOCK_MASTER_BROKER_REQUEST: {
            //     return {
            //         ...state,
            //         onestockBrokers: initialState.onestockBrokers,
            //         loading: {
            //             ...state.loading,
            //             onestockBrokers: 1
            //         }
            //     }
            // }

            // case masterConstants.ONESTOCK_MASTER_BROKER_RESPONSE: {
            //     return {
            //         ...state,
            //         onestockBrokers: payload,
            //         loading: {
            //             ...state.loading,
            //             onestockBrokers: 0,
            //         },
            //         initialCalled: {
            //             ...state.initialCalled,
            //             onestockBrokers: 1,
            //         }
            //     }
            // }

            case masterConstants.PENDING_CALL_REQUEST: {
                return {
                    ...state,
                    pendingCall: initialState.pendingCall,
                    loading: {
                        ...state.loading,
                        pendingCall: 1
                    }
                }
            }

            case masterConstants.PENDING_CALL_RESPONSE: {
                return {
                    ...state,
                    pendingCall: payload,
                    loading: {
                        ...state.loading,
                        pendingCall: 0,
                    },
                    initialCalled: {
                        ...state.initialCalled,
                        pendingCall: 1,
                    }
                }
            }

            case masterConstants.RiSK_PROFILE_DATA: {
                
                return {
                    ...state,
                    riskData: payload,
                    loading: {
                        ...state.loading,
                        riskData: 0,
                    },
                    initialCalled: {
                        ...state.initialCalled,
                        riskData: 1,
                    },
                    // riskAssessmentQuestions: payload,
                };
            }

             case masterConstants.FIRST_TIME_RENDER: {
                
                return {
                    ...state,
                    firstRender: payload,
                    loading: {
                        ...state.loading,
                      firstRender  : true,
                    },
                    initialCalled: {
                        ...state.initialCalled,
                        firstRender: true,
                    },
                };
            }

          

            default:
                return state;
        }
    }
);
